export default "__VITE_ASSET__8085577b__"